import "./_InfoPane.scss";

function InfoPane() {
	return (
		<section className="title ticket_choice">
			<h1>FooFest</h1>
			<p>A festival for everyone</p>
			<p>21.06.2022 - 26.06.2022</p>
		</section>
	);
}

export default InfoPane;
